module.exports = __webpack_public_path__ + "static/img/top2.2965bfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top2.jpg
// module id = H4Im
// module chunks = 1